import React from "react";
import type { EmailItem } from "src/types/conditionsInbox";
import Table from "src/components/Table";
import { Row, HeaderRow } from "src/components/Table/Table.styles";
import { HeaderCell } from "src/components/Table/Cells/shared/HeaderCell";
import { EmailCell, EmailRow, EmailHeaderRow } from "./EmailListSection.styles";

interface EmailListSectionProps {
  onEmailSelect?: (emailId: string) => void;
  emails: EmailItem[];
  selectedEmailId?: string | null;
}

export function EmailListSection({
  onEmailSelect,
  emails,
  selectedEmailId,
}: EmailListSectionProps) {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleString();
  };

  const Header = () => (
    <EmailHeaderRow>
      <HeaderCell title="Sender" />
      <HeaderCell title="Email Subject" />
      <HeaderCell title="Date and Time Received" />
      <HeaderCell title="Attachments" />
    </EmailHeaderRow>
  );

  const rowBuilder = (email: EmailItem) => (
    <EmailRow
      key={email.id}
      onClick={() => onEmailSelect?.(email.id)}
      isSelected={selectedEmailId === email.id}
    >
      <EmailCell>{email.senderEmail}</EmailCell>
      <EmailCell>{email.subject}</EmailCell>
      <EmailCell>{formatDate(email.receivedAt)}</EmailCell>
      <EmailCell>{email.hasAttachments ? email.attachmentCount : 0}</EmailCell>
    </EmailRow>
  );

  return <Table Header={Header} rowBuilder={rowBuilder} data={emails} />;
}
